var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#005ce6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.921 16.758l-10.675-8.3-.859-.668.862.671V24.75h23.5V8.46l-10.68 8.297a1.75 1.75 0 01-2.148 0z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.383 6.211l1.228 1.579-.862.671.866-.671-1.229-1.579z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 5H3c-.553 0-1 .447-1 1v20c0 .553.447 1 1 1h26c.553 0 1-.447 1-1V6c0-.553-.447-1-1-1zm-2.953 2.253L16 15.063 5.953 7.253zm1.703 1.21V24.75H4.25V8.462l-.863-.671.86.668 10.675 8.3a1.75 1.75 0 002.147 0L27.75 8.462l.863-.671-1.229-1.579h.003l1.229 1.579z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.64527ea5ad43b593f19b52108b1540bf.svg";
export { ForwardRef as ReactComponent };